import React, {useState, useEffect, useMemo} from 'react';
import BlogSidebar from "./BlogSidebar";
import BlogArticleCard from "./BlogArticleCard";

const POSTS_PER_PAGE = 12;
const VISIBLE_PAGE_NUMBERS = 5;

function getVisiblePageNumbers(current, total, windowSize = VISIBLE_PAGE_NUMBERS) {
    let start = Math.max(1, current - Math.floor(windowSize / 2));
    let end = Math.min(total, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);

    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
}

function BlogListingLayout({heading, posts, categories, activeCategoryLink}) {
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery, posts]);

    const filteredPosts = useMemo(() => {
        if (!posts) return null;
        const query = searchQuery.trim().toLowerCase();
        if (!query) return posts;
        return posts.filter(post => post.title && post.title.toLowerCase().includes(query));
    }, [posts, searchQuery]);

    const totalPages = filteredPosts ? Math.max(1, Math.ceil(filteredPosts.length / POSTS_PER_PAGE)) : 1;
    const pagePosts = filteredPosts
        ? filteredPosts.slice((currentPage - 1) * POSTS_PER_PAGE, currentPage * POSTS_PER_PAGE)
        : null;
    const visiblePageNumbers = getVisiblePageNumbers(currentPage, totalPages);

    return (
        <div className="blog2-container">
            <BlogSidebar
                categories={categories}
                activeCategoryLink={activeCategoryLink}
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
            />

            <div className="blog2-main">
                <div className="blog2-main-heading">
                    <p className="blog2-eyebrow">baza wiedzy</p>
                    <div className="blog2-title-row">
                        <h2 className="blog2-title">{heading}</h2>
                        <span className="blog2-count">({filteredPosts ? filteredPosts.length : 0})</span>
                    </div>
                </div>

                <div className="blog2-grid">
                    {pagePosts
                        ? (pagePosts.length > 0
                            ? pagePosts.map(post => <BlogArticleCard post={post} key={post.id}/>)
                            : <p className="blog2-empty">Brak artykułów spełniających kryteria wyszukiwania.</p>)
                        : [...Array(6)].map((_, i) => <div className="blog2-card blog2-card--skeleton" key={i}/>)
                    }
                </div>

                {totalPages > 1 && (
                    <div className="blog2-pagination">
                        {visiblePageNumbers.map(num => (
                            <button
                                key={num}
                                type="button"
                                className={"blog2-page-item" + (num === currentPage ? " blog2-page-item--active" : "")}
                                onClick={() => setCurrentPage(num)}
                            >
                                {num}
                            </button>
                        ))}
                        <button
                            type="button"
                            className="blog2-page-next"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                            aria-label="Następna strona"
                        >
                            ›
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BlogListingLayout;
